import { useQuery, useMutation } from "@tanstack/react-query";
import { useCallback } from "react";

import { queryClient } from "App";
import { useAuthentication } from "hooks/useAuthentication";
import { useToast } from "hooks/useToast";
import { API } from "utils/api";

type StockNotificationResponse = {
  has_notification: boolean;
};

type CreateNotificationResponse = {
  message: string;
};

type Props = {
  productId: string;
  skip?: boolean;
};

export const useStockNotification = ({ productId, skip }: Props) => {
  const { errorToast } = useToast();
  const { user } = useAuthentication();

  const invalidateNotification = useCallback(
    () =>
      queryClient.invalidateQueries([
        "stock_notification",
        productId,
        user?.id,
      ]),
    [productId, user?.id]
  );

  const { mutateAsync: createNotification, isLoading: isCreating } =
    useMutation({
      mutationFn: () =>
        API.post(`/products/${productId}/stock_notification`).then(
          ({ data }: { data: CreateNotificationResponse }) => data
        ),
      onSuccess: invalidateNotification,
      // onSuccess: () => {
      //   successToast("Notificación de stock creada exitosamente");
      //   invalidateNotification();
      // },
      onError: () =>
        errorToast("Error al crear la notificación, vuelva a intentarlo"),
    });

  const {
    data: notificationData,
    isLoading,
    error,
  } = useQuery<StockNotificationResponse>({
    queryKey: ["stock_notification", productId, user?.id],
    queryFn: () =>
      API.get(`/products/${productId}/stock_notification`).then(
        ({ data }: { data: StockNotificationResponse }) => data
      ),
    enabled: !!user && !!productId && !skip,
    keepPreviousData: true,
  });

  return {
    hasNotification: notificationData?.has_notification ?? false,
    isLoading: isLoading || isCreating,
    error,
    createNotification,
  };
};
